import React, { useContext, useEffect, useState } from 'react';
import { createNewValidation, getValidationList, updateValidation } from 'misc/phqHTTP';
import { Page, Validation, ValidationSearchParams } from 'models/questionnaire.model';
import { ValidationAppliesToEnum, ValidationTypeEnum } from 'models/validation.enum';
import { IonButton, IonButtons, IonContent, IonFooter, IonHeader, IonTitle, IonToolbar } from '@ionic/react';

import Editor from 'react-simple-code-editor';
import { highlight, languages } from 'prismjs';
import 'prismjs/components/prism-clike';
import 'prismjs/components/prism-javascript';
import "prismjs/themes/prism.css"
import { AppContext } from 'context/app.context';

const codeTemplate = `/**
 * State variable will adhere to the PHQGlobalModel object in QApp
 * There should be a single function that returns an array of strings (errors)
 * function(state) {
 *  // your code goes here
 *  .......
 *  return ["Allergies section is required", "Some other error", "etc"]
 * }
*/`;

const LambdaEditor = (props: { page: Page, onCancelModal: () => void }) => {

    const { page, onCancelModal } = props;
    const { notifySuccess } = useContext(AppContext);
    const [lambdaCode, setCode] = useState("// type here ...");
    const [lambda, setLambda] = useState<Validation>({
        ValidationTypeID: ValidationTypeEnum.Lambda,
        AppliesTo: ValidationAppliesToEnum.page,
        AppliesToID: page ? page.PageID : 0,
    } as Validation);

    const onSaveModal = () => {
        lambda.ValidationLogic = lambdaCode;
        const promise = lambda.ValidationID > 0
            ? updateValidation(lambda)
            : createNewValidation(lambda)

        notifySuccess("Lambda successfully saved!")

        promise.then(_ => onCancelModal() )
    }

    useEffect(() => {
        const params = {
            AppliesTo: ValidationAppliesToEnum.page,
            AppliesToID: page ? page.PageID : 0,
            ValidationTypeID: ValidationTypeEnum.Lambda
        } as ValidationSearchParams;

        getValidationList(params).then(res => {
            const lambdas = res.data.result;
            if(lambdas.length > 0) {
                const lambda = res.data.result[0];
                setLambda(lambda);
                setCode(lambda.ValidationLogic);
            }
        })
    }, [setLambda, page?.PageID])

    return (
        <div style={{display: 'contents'}}>
            <IonHeader>
                <IonToolbar color="primary">
                    <IonTitle>Lambda</IonTitle>
                </IonToolbar>
            </IonHeader>
            <IonContent scrollY>
                <Editor
                    value={codeTemplate}
                    onValueChange={() => {}}
                    highlight={c => highlight(c, languages.js, 'js')}
                    disabled={true}
                    padding={10}
                    style={{
                        fontFamily: '"Fira code", "Fira Mono", monospace',
                        fontSize: 12
                    }}
                />
                <Editor
                    value={lambdaCode}
                    onValueChange={setCode}
                    highlight={c => highlight(c, languages.js, 'js')}
                    padding={10}
                    style={{
                        fontFamily: '"Fira code", "Fira Mono", monospace',
                        fontSize: 12
                    }}
                />
            </IonContent>
            <IonFooter>
                <IonToolbar>
                    <IonButtons>
                        <IonButton fill="solid" className="w-100" onClick={onCancelModal}>Cancel</IonButton>
                        <IonButton fill="solid" className="w-100" onClick={onSaveModal}>Save</IonButton>
                    </IonButtons>
                </IonToolbar>
            </IonFooter>
        </div>
    )
}

export default LambdaEditor